import isFile from "./is-file"
import isGatsbyLink from "./is-gatsby-link"

export { isFile, isGatsbyLink }
